import { Box, Spinner } from '@factorialco/deprecated-design-system'

/**
 * This component should be used when you need to show a loading at the center of the page
 * because async operations are running before an entire page could be rendered.
 *
 * If you need to show the loading spinner on a specific place, you should consider just using the Spinner component from gamma
 */
const PayrollPageLoading = () => {
  return (
    <Box width="full" alignItems="center" justifyContent="center" paddingTop="s120">
      <Spinner />
    </Box>
  )
}

export default PayrollPageLoading
